module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/guide-renting-small-89a840eacb37825c41f720beb7063ebc.svg";